import {genderOptions,kpisMapping} from './constants'

const OCCUPATION_PLACEHOLDER = '[occupation]';
const GENDER_PLACEHOLDER = '[gender]';
const JOB_CATEGORY_PLACEHOLDER = '[job category]';
const KPI_NAME_PLACEHOLDER = '[KPI_name]';
const COUNTRY_PLACEHOLDER = '[country]';
const STATE_PLACEHOLDER = '[state]';


export const chartKpiDataFieldRefTransformationMultipleCharts=(docs)=>{

    if(docs && Array.isArray(docs)){
    docs.forEach(doc => {
      if(doc.kpiData && Array.isArray(doc.kpiData)){
        doc.kpiData.forEach(data => {
          if (data.seniority_ref && data.seniority_ref._id) {
            data.seniorityId = data.seniority_ref;
          }
          if (data.occupation_ref && data.occupation_ref._id) {
            data.occupationId = data.occupation_ref
          }
          if (data.ethnicity_ref && data.ethnicity_ref._id) {
            data.ethnicityId = data.ethnicity_ref
          }
          if (data.veteran_ref && data.veteran_ref._id) {
            data.veteranId = data.veteran_ref
          }
          if (data.sexualOrientation_ref && data.sexualOrientation_ref._id) {
            data.sexualOrientationId = data.sexualOrientation_ref
          }
          if (data.religion_ref && data.religion_ref._id) {
            data.religionId = data.religion_ref
          }
          if (data.disability_ref && data.disability_ref._id) {
            data.disabilityId = data.disability_ref
          }
          if (data.kpi_ref && data.kpi_ref._id) {
            data.kpiId = data.kpi_ref
          }
        });
      }
      
    });
  }


  return docs
}


export const chartKpiDataFieldRefTransformationSingleChart=(doc)=>{

  if(doc.kpiData && Array.isArray(doc.kpiData)){
    doc.kpiData.forEach(data => {
      if (data.seniority_ref && data.seniority_ref._id) {
        data.seniorityId = data.seniority_ref;
      }
      if (data.occupation_ref && data.occupation_ref._id) {
        data.occupationId = data.occupation_ref
      }
      if (data.ethnicity_ref && data.ethnicity_ref._id) {
        data.ethnicityId = data.ethnicity_ref
      }
      if (data.veteran_ref && data.veteran_ref._id) {
        data.veteranId = data.veteran_ref
      }
      if (data.sexualOrientation_ref && data.sexualOrientation_ref._id) {
        data.sexualOrientationId = data.sexualOrientation_ref
      }
      if (data.religion_ref && data.religion_ref._id) {
        data.religionId = data.religion_ref
      }
      if (data.disability_ref && data.disability_ref._id) {
        data.disabilityId = data.disability_ref
      }
      if (data.kpi_ref && data.kpi_ref._id) {
        data.kpiId = data.kpi_ref
      }
    });
  }

  return doc
}

export const generateLegendTitle = (kpiData,description, i, isBenchmark, industry, benchmarkLocation) => {
  
  let legendDescription;
  
  // console.log('desc----',)

  let legendText=`(KPI ${i+1})`
  // console.log(kpiData)

  
  if(kpiData){
        const {score, kpiId,occupationId,genderId, veteranId, religionId, 
          sexualOrientationId, seniorityId,location,diversityType} = kpiData;

          // console.log('kpiData: ', kpiData)
       
        let isAllGender = kpisMapping[kpiId.code] && kpisMapping[kpiId.code].activeGenders &&  kpisMapping[kpiId.code].kpiType== 'SURVEY_BASED'
                            && kpisMapping[kpiId.code].activeGenders.length==1  && kpisMapping[kpiId.code].activeGenders[0]!=''? kpisMapping[kpiId.code].activeGenders[0]:false
       


        if(isBenchmark) {
          legendDescription = `Benchmark: ${description}`;   
        }else {
          legendDescription =  description;
        }

        let ethnicity=""
        let diversity=''

        if(score && score[0]){
            if(isBenchmark && ( (score[0] && score[0].kpiCode && score[0].kpiCode.indexOf("COMP")===-1) || (kpiId && kpiId.code && kpiId.code.indexOf("COMP-1")===-1 )) ){ 
              legendDescription = legendDescription.replace(KPI_NAME_PLACEHOLDER,`Industry : ${industry}`);
            } else if(kpiId) {
              legendDescription = legendDescription.replace(KPI_NAME_PLACEHOLDER,kpiId.name);
              legendText = legendText+` ${kpiId.name}:`
            } else {
              legendDescription = legendDescription.replace(KPI_NAME_PLACEHOLDER,'');
            }

            
            if(score && score[0] && (score[0].ethnicity || score[0].numeratorEthnicity) ){
              let value = score[0].ethnicity?score[0].ethnicity: score[0].numeratorEthnicity
              ethnicity=value
            } else if (kpiData.ethnicityId && kpiData.ethnicityId.name){
              ethnicity=kpiData.ethnicityId.name
            }

        
            // console.log('score---', score[0])
            let val = score[0]&& score[0].data && score[0].data.numeratorType?score[0].data.numeratorType:score[0].numeratorType
            if(score && score[0] && val){
              if(val.indexOf('-')>-1){
                diversity = val.substring(1).replace(/-/g,' ').toLowerCase()
              } else {
                diversity = val.replace(/-/g,' ').toLowerCase()
              }
            }
      }




        let selectedGender = isAllGender? '': genderOptions.filter(gender => gender.id === diversityType);


        // console.log('selectedGender: ', selectedGender)
        // console.log('diversity: ', diversity)
        // console.log('diversityType: ', diversityType)
        // console.log('kpisMapping: ',kpisMapping[kpiId.code])
        // console.log('kpiId.code: ', kpiId.code)
        // console.log('kpiId: ', kpiId)

        if (selectedGender && selectedGender[0]!==undefined) {
          if(diversity!==''){
            legendDescription = legendDescription.replace(GENDER_PLACEHOLDER, diversity);
            legendText = legendText+` ${diversity}`

          } else {
            legendDescription = legendDescription.replace(GENDER_PLACEHOLDER, selectedGender[0].name );
            legendText = legendText+` ${selectedGender[0].name}`
          }
        } else {
          if(isAllGender!=true &&diversity!==''){
            legendDescription = legendDescription.replace(GENDER_PLACEHOLDER, diversity);
            legendText = legendText+` ${diversity}`
          } 
          else {
            isAllGender = isAllGender=='All'?'':isAllGender
            legendDescription = legendDescription.replace(GENDER_PLACEHOLDER, isAllGender);
            legendText = legendText 
          }
        }

        
        if(occupationId) {
          legendDescription = legendDescription.replace(OCCUPATION_PLACEHOLDER,occupationId.name);
          legendText = legendText+` ${occupationId.name}`
        } 
        else {
          legendDescription = legendDescription.replace(OCCUPATION_PLACEHOLDER,"All");
        }

        if(seniorityId) {
          legendDescription = legendDescription.replace(JOB_CATEGORY_PLACEHOLDER,seniorityId.name);
          legendText = legendText+` ${seniorityId.name}`
        } 
   
        
        if(isBenchmark){
          if(benchmarkLocation && benchmarkLocation.name) {
            let country = "USA";
            legendDescription = legendDescription.replace(COUNTRY_PLACEHOLDER,country);
            legendDescription = legendDescription.replace(STATE_PLACEHOLDER,benchmarkLocation.name);
          }
      
        } else {
          if(location && location.values && location.values.length > 0) {
            let country = location.country && location.country!==null?location.country: "USA"
            legendDescription = legendDescription.replace(COUNTRY_PLACEHOLDER,country);
            legendDescription = legendDescription.replace(STATE_PLACEHOLDER,location.values);
          } 
        
        }


              const existWithAvgTenure = score.find(
                (x) => x.avgTenure && x.avgTenure != null
              );

              if (existWithAvgTenure) {
                legendText +="- with Tenure"
              }

  } else { 
    // console.log("bench")
    // legendDescription = `Benchmark: ${description}, [KPI_name], Group: [gender], Occupation: [occupation], Job category: [job category], Country: [country], State: [state], as of date`;   
    let diversityType, seniorityId
    legendDescription = `Benchmark: ${description}, [KPI_name], [gender], [occupation], [job category], [country], [state]`;   

    // console.log('legend B')
    if(isBenchmark){ 
      legendDescription = legendDescription.replace(KPI_NAME_PLACEHOLDER,`Industry : ${industry}`);
    } else {
      legendDescription = legendDescription.replace(KPI_NAME_PLACEHOLDER,'');
    }
    
    legendDescription = legendDescription.replace(OCCUPATION_PLACEHOLDER,"All");
    // console.log(legendDescription)

    legendDescription = legendDescription.replace(GENDER_PLACEHOLDER, 'All');


    legendDescription = legendDescription.replace(JOB_CATEGORY_PLACEHOLDER,"All");


    if(benchmarkLocation && benchmarkLocation.name) {
      let country = "USA";
      legendDescription = legendDescription.replace(COUNTRY_PLACEHOLDER,country);
      legendDescription = legendDescription.replace(STATE_PLACEHOLDER,benchmarkLocation.name);
    } else {
      legendDescription = legendDescription.replace(COUNTRY_PLACEHOLDER,"All");
      legendDescription = legendDescription.replace(STATE_PLACEHOLDER,"All");
    }
    
  }

  if(legendText && legendText.indexOf(':')>-1){
    let sub_legend = legendText.split(':')
    let legend_idx= legendText.indexOf(":")  
    if(/^\s*$/.test(sub_legend[1] )) {
       legendText = legendText.slice(0,legend_idx)
    }
  }



  return legendText
}
